import { motion, AnimatePresence } from "framer-motion";
import React, { useState } from "react";
import { animatePages, transition } from "../animation/animate";
import { about } from "./data/aboutData";

const About = () => {
  const [value, setValue] = useState(2);
  const { text } = about[value];

  return (
    <motion.section
      initial="out"
      animate="in"
      exit="out"
      variants={animatePages}
      transition={transition}
      className="section about-section"
    >
      <div className="section-contents-wrapper container">
        <div className="section-title">
          <h1>About Myself</h1>
        </div>
        {/* img */}
        <div className="about-wrapper">
          <div className="profile-img"></div>
          <div className="section-content">
            <div className="bio-length">
              <p>Adjust Bio Length:</p>
              <div className="dots-wrapper">
                {about.map((item, i) => {
                  let status;
                  if (value === i) {
                    status = "dot-active";
                  }
                  return (
                    <button
                      key={item.id}
                      className={`dot ${status}`}
                      onClick={() => setValue(i)}
                    ></button>
                  );
                })}
              </div>
              <div className="length-tags">
                <p>shortest</p>
                <p>Longest</p>
              </div>
            </div>
            <AnimatePresence exitBeforeEnter>
              <motion.div style={{ overflow: "hidden" }}>
                <motion.div
                  key={value}
                  className="bio-text active-text"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{
                    opacity: 1,
                    y: 0,
                  }}
                  transition={{
                    duration: 0.5,
                  }}
                  exit={{ opacity: 0, y: -20 }}
                >
                  {text.map((text, i) => {
                    return <p key={i}>{text}</p>;
                  })}
                </motion.div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
